import HGClickToCopy from 'components/HGClickToCopy';
import EditNameButton from 'components/EditNameButton';
import { ViewLogsButton } from 'components/DeviceLogs/ViewLogsButton';
import CounterBadge from '../../Alerts/CounterBadge';
import { OnlineStatus } from '../../../components/DeviceList/OnlineStatus';

export const batteryModulesTableColumns = [
    {
        Header: 'Status',
        accessor: 'status',
        component: (item) => <OnlineStatus device={item} />,
    },
    {
        Header: 'Alerts',
        accessor: 'Thing_ID',
        component: (item) => <CounterBadge item={item} />,
    },
    {
        Header: 'Name',
        accessor: 'PackName',
        component: (item) => (
            <EditNameButton item={{ ...item, fromTable: true }} />
        ),
    },
    {
        Header: 'Charge (%)',
        accessor: 'SoC',
    },
    {
        Header: 'Health (%)',
        accessor: 'SoH',
    },
    {
        Header: 'Current',
        accessor: 'current',
    },
    {
        Header: 'State',
        accessor: 'charging',
    },
    {
        Header: 'Temperature',
        accessor: 'temp_c',
    },
    {
        Header: 'Serial Number',
        accessor: 'P_serialNumber',
        component: (item) => (
            <HGClickToCopy content={item?.P_serialNumber}>
                <span className="text-foreground">{item?.P_serialNumber}</span>
            </HGClickToCopy>
        ),
    },
    {
        Header: 'Logs',
        accessor: 'online',
        component: (item) => (
            <ViewLogsButton device={item}>View Logs</ViewLogsButton>
        ),
        nosort: true,
    },
];
